/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { getLookupPiyasalar, getLookupParaBirimleri } from "./apiCache";
import * as XLSX from "xlsx";

// ── Dark theme paleti (CapaTarama.jsx referansı) ─────────────────────────────
const C = {
    bg:     "#0f172a",
    panel:  "#1e293b",
    border: "#334155",
    text:   "#e2e8f0",
    muted:  "#94a3b8",
    accent: "#3b82f6",
    yesil:  "#22c55e",
    kirmizi:"#ef4444",
    sari:   "#eab308",
};

const AYAR_ALANLAR = [
    { key: "sermaye",                 label: "Sermaye (Paper)",           tip: "para" },
    { key: "pozisyon_buyuklugu",      label: "Pozisyon Büyüklüğü",        tip: "para" },
    { key: "max_acik_pozisyon",       label: "Max Açık Pozisyon",         tip: "sayi" },
    { key: "ayni_sektor_max",         label: "Aynı Sektörden Max",        tip: "sayi" },
    { key: "min_gecerlilik_skoru",    label: "Min Geçerlilik Skoru",      tip: "sayi" },
    { key: "gunluk_kayip_limiti_pct", label: "Günlük Kayıp Limiti (%)",   tip: "sayi" },
    { key: "ardisik_stop_limiti",     label: "Ardışık Stop Limiti",       tip: "sayi", bilgi: "ardisik_stop" },
    { key: "veri_tazelik_dk",         label: "Veri Tazeliği (dk)",        tip: "sayi", bilgi: "veri_tazelik" },
];

// Binlik ayraç: 100000 → "100.000" (görüntü), "100.000" → 100000 (kayıt)
const binlikGoster = v =>
    (v === null || v === undefined || v === "") ? ""
        : Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 0 });
const binlikCoz = s => {
    const ham = String(s).replace(/[^\d]/g, "");
    return ham === "" ? null : Number(ham);
};

const SEBEP_RENK = {
    STOP: C.kirmizi, HEDEF1: C.yesil, HEDEF2: C.yesil,
    SINYAL_GECERSIZ: C.sari, MANUEL: C.muted, LIMIT_TTL: C.muted,
};

// ── Bilgi kartları içeriği ("i" ikonu üzerine gelince ikonun altında açılır) ──
const BILGI_ICERIK = {
    kill_switch: "Kill-Switch, tanımlı güvenlik kurallarından biri ihlal edildiğinde " +
        "(günlük kayıp limiti aşımı, ardışık stop sayısı, bayat veri) botun YENİ pozisyon " +
        "açmasını otomatik olarak durduran, bot döngüsünden bağımsız bir güvenlik katmanıdır. " +
        "Açık pozisyonları kapatmayı engellemez — sadece yeni açılışları durdurur.",
    ardisik_stop: "Art arda, kesintisiz STOP ile kapanan işlem sayısı bu limite ulaştığında " +
        "Kill-Switch botu otomatik olarak durdurur. Ardışık kayıpların birikerek büyümesini önler.",
    veri_tazelik: "Son fiyat güncellemesinin üzerinden bu süreden (dakika) fazla zaman geçtiyse " +
        "bot güvenlik amacıyla yeni pozisyon açmaz. Veri tazelenince bu kısıtlama otomatik kalkar.",
    sinyal_kaynagi: "Botun pozisyon açarken hangi sinyal üreticisini (mod_kaynak) dinleyeceğini " +
        "belirler — örn. 'YATIRIM_ONERISI' seçiliyse yalnızca Yatırım Önerisi Motoru'nun " +
        "ürettiği sinyaller değerlendirilir, diğer modüllerin (FVG, DIP, vb.) sinyalleri yok sayılır.",
    expectancy: "Ortalama işlem başına beklenen kazanç yüzdesi: (kazanma oranı × ortalama kazanç) " +
        "− (kaybetme oranı × ortalama kayıp). Pozitif olması, stratejinin uzun vadede kâr üretmeye " +
        "eğilimli olduğunu gösterir.",
    profit_factor: "Kapanan kazançlı işlemlerin toplam kârının, kapanan kayıplı işlemlerin toplam " +
        "zararına oranıdır. 1'in üzerinde olması toplam kazançların toplam kayıpları aştığı anlamına gelir.",
    max_drawdown: "Sermayenin, kümülatif kâr eğrisindeki en yüksek noktadan sonraki en büyük düşüş " +
        "yüzdesidir — stratejinin geçmişte yaşanabilecek en kötü sermaye erimesini gösterir.",
    ort_mfe: "MFE (Maximum Favorable Excursion): pozisyon açıkken fiyatın LEHTE gittiği en uzak " +
        "noktanın giriş fiyatına göre ortalama yüzdesi. Hedeflerin ne kadar 'yakalanabilir' olduğunu gösterir.",
    ort_mae: "MAE (Maximum Adverse Excursion): pozisyon açıkken fiyatın ALEYHTE gittiği en uzak " +
        "noktanın giriş fiyatına göre ortalama yüzdesi. Stop seviyelerinin isabetini değerlendirmede kullanılır.",
    mfe_pct: "Bu pozisyon açıldığından bu yana fiyatın LEHTE gittiği en uzak noktanın, giriş " +
        "fiyatına göre yüzdesi.",
    mae_pct: "Bu pozisyon açıldığından bu yana fiyatın ALEYHTE gittiği en uzak noktanın, giriş " +
        "fiyatına göre yüzdesi.",
    slip_pct: "Slippage: emrin verildiği andaki fiyat ile gerçekleşen (fill) fiyat arasındaki " +
        "farkın yüzdesi. Paper işlemlerde bu, Likidite Derinliği modülünün tahminine göre " +
        "her zaman ALEYHTE uygulanır (alışta daha pahalıya, satışta daha ucuza) — gerçek " +
        "piyasa koşullarını daha gerçekçi şekilde simüle etmek içindir.",
    cron_zinciri: "Botun platform altyapısını sırayla kontrol ettiği otomatik çalıştırma zinciri: " +
        "Veri tazeliği → Piyasa rejimi → Sinyal kontrolü → Kill-Switch → Bot döngüsü. Bir adım " +
        "'DURDU' verirse o çalıştırmadaki sonraki adımlar 'ATLANDI' olarak işaretlenir.",
    dongu_log: "Botun her değerlendirme turunda kaç sinyal incelediğini, kaç pozisyon açıp " +
        "kapattığını, kaçını neden atladığını (sembol zaten açık, sektör dolu, izin yok vb.) " +
        "kayıt altına alan detaylı çalışma günlüğüdür.",
};

const BilgiIkonu = ({ anahtar }) => {
    const [acik, setAcik] = useState(false);
    return (
        <span style={{ position: "relative", display: "inline-block", marginLeft: 5 }}
              onMouseEnter={() => setAcik(true)}
              onMouseLeave={() => setAcik(false)}>
            <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 15, height: 15, borderRadius: "50%", background: C.border,
                color: C.muted, fontSize: 10, fontStyle: "italic", fontWeight: 700,
                cursor: "help", userSelect: "none", lineHeight: 1,
            }}>i</span>
            {acik && (
                <div style={{
                    position: "absolute", top: "130%", left: 0, zIndex: 100,
                    width: 240, padding: "10px 12px", background: C.panel,
                    border: `1px solid ${C.border}`, borderRadius: 8,
                    boxShadow: "0 4px 14px rgba(0,0,0,0.45)",
                    fontSize: 12, lineHeight: 1.5, color: C.text, fontWeight: 400,
                    whiteSpace: "normal",
                }}>
                    {BILGI_ICERIK[anahtar]}
                </div>
            )}
        </span>
    );
};

export default function BotPanosu() {
    const [piyasa,     setPiyasa]     = useState("BIST");
    const [piyasaSecenekleri, setPiyasaSecenekleri] = useState(["BIST", "Kripto"]);
    const [paraBirimi, setParaBirimi] = useState("TL");
    const [paraBirimiSecenekleri, setParaBirimiSecenekleri] = useState(["TL", "USD"]);
    const [ayar,       setAyar]       = useState(null);
    const [ayarTaslak, setAyarTaslak] = useState({});
    const [kill,       setKill]       = useState(null);
    const [metrik,     setMetrik]     = useState(null);
    const [acikPoz,    setAcikPoz]    = useState([]);
    const [kapaliPoz,  setKapaliPoz]  = useState([]);
    const [zincir,     setZincir]     = useState([]);
    const [donguLog,   setDonguLog]   = useState([]);
    const [yukleniyor, setYukleniyor] = useState(false);
    const [kaydediyor, setKaydediyor] = useState(false);
    const [tetikleniyor, setTetikleniyor] = useState(false);
    const [durdurPopup, setDurdurPopup]   = useState(false);
    const [durdurSebep, setDurdurSebep]   = useState("");
    const [kapatPopup,  setKapatPopup]    = useState(null); // islem objesi
    const intervalRef = useRef(null);

    const getToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.access_token;
    };
    const auth = async () => ({ headers: { Authorization: `Bearer ${await getToken()}` } });

    // ── Piyasa/Para Birimi lookup — DB'den (diğer modüllerdeki kalıp) ─────────
    useEffect(() => {
        getLookupPiyasalar()
            .then(list => { if (list?.length) setPiyasaSecenekleri(list); })
            .catch(() => {});
    }, []);

    // Botla ilgisiz endeks-özel para birimi seçenekleri (ör. BIST100 (TL)/(USD))
    // burada gösterilmez; Kripto için de yalnızca USD ve USD (Futures) sunulur.
    const YASAKLI_PARA_BIRIMLERI = new Set(["BIST100 (TL)", "BIST100 (USD)"]);
    const paraBirimiFiltrele = (piyasa, liste) => {
        let filtreli = (liste || []).filter(x => !YASAKLI_PARA_BIRIMLERI.has(x));
        if (piyasa === "Kripto") {
            filtreli = filtreli.filter(x => x === "USD" || x === "USD (Futures)");
        }
        if (!filtreli.length) {
            filtreli = piyasa === "Kripto" ? ["USD", "USD (Futures)"] : ["TL", "USD"];
        }
        return filtreli;
    };

    useEffect(() => {
        const varsayilan = piyasa === "BIST" ? "TL" : "USD";
        getLookupParaBirimleri(piyasa)
            .then(list => {
                const filtreli = paraBirimiFiltrele(piyasa, list);
                setParaBirimiSecenekleri(filtreli);
                setParaBirimi(filtreli.includes(varsayilan) ? varsayilan : filtreli[0]);
            })
            .catch(() => {
                const filtreli = paraBirimiFiltrele(piyasa, null);
                setParaBirimiSecenekleri(filtreli);
                setParaBirimi(varsayilan);
            });
    }, [piyasa]);

    // ── Veri yükleme ─────────────────────────────────────────────────────────
    const hepsiniYukle = async (sessiz = false) => {
        if (!sessiz) setYukleniyor(true);
        try {
            const h = await auth();
            const pb = { piyasa, para_birimi: paraBirimi };
            const [a, k, m, ap, kp, z, dl] = await Promise.all([
                axios.get(`${API_URL}/scan/bot/ayarlar`,      { ...h, params: pb }),
                axios.get(`${API_URL}/scan/bot/kill-durum`,   { ...h, params: pb }),
                axios.get(`${API_URL}/scan/bot/metrikler`,    { ...h, params: pb }),
                axios.get(`${API_URL}/scan/bot/pozisyonlar`,  { ...h, params: { ...pb, durum: "ACIK" } }),
                axios.get(`${API_URL}/scan/bot/pozisyonlar`,  { ...h, params: { ...pb, durum: "KAPALI" } }),
                axios.get(`${API_URL}/scan/bot/zincir-log`,   { ...h, params: { piyasa, limit: 5 } }),
                axios.get(`${API_URL}/scan/bot/dongu-log`,    { ...h, params: { ...pb, limit: 15 } }),
            ]);
            setAyar(a.data.ayar);       setAyarTaslak(a.data.ayar || {});
            setKill(k.data.durum);
            setMetrik(m.data.metrikler);
            setAcikPoz(ap.data.pozisyonlar || []);
            setKapaliPoz(kp.data.pozisyonlar || []);
            setZincir(z.data.zincirler || []);
            setDonguLog(dl.data.loglar || []);
        } catch (e) {
            if (!sessiz) toast.error("Pano yüklenemedi: " + (e.response?.data?.detail || e.message));
        } finally {
            if (!sessiz) setYukleniyor(false);
        }
    };

    useEffect(() => {
        hepsiniYukle();
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => hepsiniYukle(true), 60000);
        return () => clearInterval(intervalRef.current);
    }, [piyasa, paraBirimi]);

    // ── Aksiyonlar ───────────────────────────────────────────────────────────
    const ayarKaydet = async () => {
        setKaydediyor(true);
        try {
            const h = await auth();
            await axios.post(`${API_URL}/scan/bot/ayarlar`,
                { piyasa, para_birimi: paraBirimi, ayarlar: ayarTaslak }, h);
            toast.success("Ayarlar kaydedildi");
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Kaydedilemedi: " + (e.response?.data?.detail || e.message));
        } finally { setKaydediyor(false); }
    };

    const botAktifToggle = async () => {
        try {
            const h = await auth();
            await axios.post(`${API_URL}/scan/bot/ayarlar`,
                { piyasa, para_birimi: paraBirimi, ayarlar: { aktif: !ayar?.aktif } }, h);
            toast.success(!ayar?.aktif ? "Bot AKTİF edildi" : "Bot pasif edildi");
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Değiştirilemedi: " + (e.response?.data?.detail || e.message));
        }
    };

    const acilDurdur = async () => {
        try {
            const h = await auth();
            await axios.post(`${API_URL}/scan/bot/acil-durdur`,
                { piyasa, para_birimi: paraBirimi, sebep: durdurSebep || "Panodan manuel acil durdurma" }, h);
            toast.success("Kill-switch DURDURULDU");
            setDurdurPopup(false); setDurdurSebep("");
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Durdurulamadı: " + (e.response?.data?.detail || e.message));
        }
    };

    const devamEttir = async () => {
        try {
            const h = await auth();
            await axios.post(`${API_URL}/scan/bot/devam`, { piyasa, para_birimi: paraBirimi }, h);
            toast.success("Kill-switch yeniden AKTİF");
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Başlatılamadı: " + (e.response?.data?.detail || e.message));
        }
    };

    const donguTetikle = async (zincirMi) => {
        setTetikleniyor(true);
        try {
            const h = await auth();
            const url = zincirMi ? "zincir-calistir" : "dongu-calistir";
            const body = zincirMi ? { piyasa } : { piyasa, para_birimi: paraBirimi };
            const res = await axios.post(`${API_URL}/scan/bot/${url}`, body, h);
            toast.success(zincirMi
                ? `Zincir: ${res.data.sonuc?.sonuc || "çalıştı"} (${piyasa} — tüm para birimleri)`
                : `Döngü [${paraBirimi}]: açılan ${res.data.sonuc?.acilan ?? 0}, kapanan ${res.data.sonuc?.kapanan ?? 0}`);
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Tetiklenemedi: " + (e.response?.data?.detail || e.message));
        } finally { setTetikleniyor(false); }
    };

    const pozisyonKapat = async () => {
        if (!kapatPopup) return;
        try {
            const h = await auth();
            const res = await axios.post(`${API_URL}/scan/bot/pozisyon-kapat`,
                { islem_id: kapatPopup.id }, h);
            toast.success(res.data.sonuc?.mesaj || "Pozisyon kapatıldı");
            setKapatPopup(null);
            hepsiniYukle(true);
        } catch (e) {
            toast.error("Kapatılamadı: " + (e.response?.data?.detail || e.message));
        }
    };

    const excelIndir = () => {
        if (!kapaliPoz.length) { toast.error("Kapanmış işlem yok"); return; }
        const ws = XLSX.utils.json_to_sheet(kapaliPoz.map(r => ({
            "Sembol": r.sembol, "Yön": r.yon, "Kaynak": r.mod_kaynak,
            "Giriş Zamanı": r.giris_zaman, "Giriş Fiyat": r.giris_fiyat,
            "Slip %": r.slip_pct, "Çıkış Zamanı": r.cikis_zaman,
            "Çıkış Fiyat": r.cikis_fiyat, "Çıkış Sebep": r.cikis_sebep,
            "PnL": r.pnl_tutar, "PnL %": r.pnl_pct,
            "MFE %": r.mfe_pct, "MAE %": r.mae_pct, "Sektör": r.sektor,
        })));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Paper İşlemler");
        XLSX.writeFile(wb, `bot_paper_${piyasa}_${paraBirimi}_${new Date()
            .toLocaleDateString("tr-TR").replace(/\./g, "-")}.xlsx`);
        toast.success("Excel indiriliyor...");
    };

    // ── Yardımcı stiller ─────────────────────────────────────────────────────
    const kart = {
        background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
        padding: "16px 20px", marginBottom: 16,
    };
    const kartBaslik = {
        fontSize: 14, fontWeight: 700, color: C.text, margin: "0 0 12px 0",
        display: "flex", alignItems: "center", gap: 8,
    };
    const pill = (aktif) => ({
        padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600,
        cursor: "pointer", border: `1.5px solid ${aktif ? C.accent : C.border}`,
        background: aktif ? C.accent : "transparent",
        color: aktif ? "#fff" : C.muted,
    });
    const buton = (renk = C.accent, disabled = false) => ({
        padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600,
        cursor: disabled ? "not-allowed" : "pointer", border: "none",
        background: renk, color: "#fff", opacity: disabled ? 0.5 : 1,
    });
    const input = {
        background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8,
        color: C.text, padding: "7px 10px", fontSize: 13, width: "100%",
        boxSizing: "border-box",
    };
    const th = {
        padding: "8px 10px", textAlign: "left", fontSize: 11, fontWeight: 700,
        color: C.muted, background: C.bg, borderBottom: `1px solid ${C.border}`,
        whiteSpace: "nowrap",
    };
    const td = {
        padding: "8px 10px", fontSize: 12, borderBottom: `1px solid ${C.border}`,
        color: C.text, whiteSpace: "nowrap",
    };
    const num = (v, b = 2) => (v === null || v === undefined) ? "—"
        : Number.parseFloat(v).toLocaleString("tr-TR", { maximumFractionDigits: b });
    const pnlRenk = (v) => v > 0 ? C.yesil : v < 0 ? C.kirmizi : C.muted;
    const zamanFmt = (z) => z ? new Date(z).toLocaleString("tr-TR",
        { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

    const killAktif = kill?.durum === "AKTIF";

    // Açık pozisyon özet metrikleri — mevcut anlık fiyatlı acikPoz'dan client-side hesaplanır
    // (backend'e ekstra fiyat sorgusu yaptırmamak için; /pozisyonlar zaten anlık fiyatları getiriyor).
    const acikMaliyet = acikPoz.reduce((s, p) => s + (Number(p.pozisyon_tutar) || 0), 0);
    const acikDeger = acikPoz.reduce((s, p) => {
        const miktar = Number(p.miktar) || 0;
        const fiyat = (p.anlik_fiyat !== null && p.anlik_fiyat !== undefined) ? Number(p.anlik_fiyat) : null;
        return s + (fiyat !== null ? fiyat * miktar : (Number(p.pozisyon_tutar) || 0));
    }, 0);
    const acikPnl = acikDeger - acikMaliyet;
    const acikPnlPct = acikMaliyet ? (acikPnl / acikMaliyet * 100) : null;
    const toplamVarlik = (Number(ayar?.sermaye) || 0) + acikDeger;

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <div style={{ minHeight: "100vh", width: "100%", background: C.bg }}>
        <div style={{ padding: 24, width: "100%", boxSizing: "border-box",
                      fontFamily: "Inter, system-ui, sans-serif", color: C.text }}>

            {/* ── Başlık ── */}
            <div style={{ display: "flex", justifyContent: "space-between",
                          alignItems: "flex-end", flexWrap: "wrap", gap: 12,
                          marginBottom: 18 }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>
                        🤖 Bot Panosu — Katman 5 (Paper Trading)
                    </h1>
                    <p style={{ margin: "3px 0 0", fontSize: 13, color: C.muted }}>
                        Karar döngüsü · Paper executor · Kill-switch · Cron orkestrasyon
                    </p>
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    {piyasaSecenekleri.map(p => (
                        <button key={p} style={pill(piyasa === p)}
                                onClick={() => setPiyasa(p)}>{p}</button>
                    ))}
                    <div style={{ width: 1, height: 20, background: C.border, margin: "0 2px" }} />
                    {paraBirimiSecenekleri.map(pb => (
                        <button key={pb} style={pill(paraBirimi === pb)}
                                onClick={() => setParaBirimi(pb)}>{pb}</button>
                    ))}
                    <button style={buton(C.border)} onClick={() => hepsiniYukle()}>
                        {yukleniyor ? "⏳" : "🔄"} Yenile
                    </button>
                </div>
            </div>

            {/* ── Kill-switch + Bot durumu ── */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div style={{ ...kart,
                              borderLeft: `4px solid ${killAktif ? C.yesil : C.kirmizi}` }}>
                    <div style={kartBaslik}>🛡️ Kill-Switch ({piyasa} / {paraBirimi})<BilgiIkonu anahtar="kill_switch" /></div>
                    <div style={{ fontSize: 20, fontWeight: 800,
                                  color: killAktif ? C.yesil : C.kirmizi }}>
                        {kill?.durum || "—"}
                    </div>
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>
                        {kill?.sebep ? `Sebep: ${kill.sebep}` : "Tüm kurallar temiz"}
                        {kill?.zaman ? ` · ${zamanFmt(kill.zaman)}` : ""}
                        {kill?.kaynak ? ` · ${kill.kaynak}` : ""}
                    </div>
                    <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                        {killAktif ? (
                            <button style={buton(C.kirmizi)}
                                    onClick={() => setDurdurPopup(true)}>
                                🛑 Acil Durdur
                            </button>
                        ) : (
                            <button style={buton(C.yesil)} onClick={devamEttir}>
                                ▶ Yeniden Başlat
                            </button>
                        )}
                    </div>
                </div>

                <div style={{ ...kart,
                              borderLeft: `4px solid ${ayar?.aktif ? C.yesil : C.muted}` }}>
                    <div style={kartBaslik}>⚙️ Bot Durumu ({piyasa} / {paraBirimi})</div>
                    <div style={{ fontSize: 20, fontWeight: 800,
                                  color: ayar?.aktif ? C.yesil : C.muted }}>
                        {ayar ? (ayar.aktif ? "AKTİF" : "PASİF") : "—"}
                    </div>
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>
                        Sinyal kaynağı: {ayar?.yom_mod_kaynak || "—"} ·
                        Emir tipi: {ayar?.emir_tipi || "—"}
                    </div>
                    <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
                        <button style={buton(ayar?.aktif ? C.muted : C.yesil)}
                                onClick={botAktifToggle}>
                            {ayar?.aktif ? "⏸ Botu Durdur" : "▶ Botu Aktif Et"}
                        </button>
                        <button style={buton(C.accent, tetikleniyor)}
                                disabled={tetikleniyor}
                                onClick={() => donguTetikle(false)}>
                            🔁 Döngüyü Şimdi Çalıştır
                        </button>
                        <button style={buton("#8b5cf6", tetikleniyor)}
                                disabled={tetikleniyor}
                                onClick={() => donguTetikle(true)}>
                            ⛓️ Zinciri Şimdi Çalıştır
                        </button>
                    </div>
                </div>
            </div>

            {/* ── Ayarlar ── */}
            <div style={kart}>
                <div style={kartBaslik}>🔧 Bot Ayarları ({piyasa} / {paraBirimi})</div>
                <div style={{ display: "grid",
                              gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                              gap: 12 }}>
                    {AYAR_ALANLAR.map(a => {
                        const pasif = a.key === "pozisyon_buyuklugu"
                            && !!ayarTaslak?.pozisyon_buyuklugu_sinyalden;
                        return (
                        <div key={a.key}>
                            <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>
                                {a.label}{pasif ? " (sinyal kaynağından)" : ""}
                                {a.bilgi ? <BilgiIkonu anahtar={a.bilgi} /> : null}
                            </div>
                            {a.tip === "para" ? (
                                <input style={{ ...input, opacity: pasif ? 0.5 : 1 }}
                                    type="text" inputMode="numeric" disabled={pasif}
                                    value={pasif ? "" : binlikGoster(ayarTaslak?.[a.key])}
                                    placeholder={pasif ? "Sinyalden alınıyor" : ""}
                                    onChange={e => setAyarTaslak(p => ({
                                        ...p, [a.key]: binlikCoz(e.target.value) }))} />
                            ) : (
                                <input style={{ ...input, opacity: pasif ? 0.5 : 1 }}
                                    type="number" disabled={pasif}
                                    value={ayarTaslak?.[a.key] ?? ""}
                                    onChange={e => setAyarTaslak(p => ({
                                        ...p, [a.key]: e.target.value === "" ? null
                                            : Number(e.target.value) }))} />
                            )}
                        </div>
                        );
                    })}
                    <div>
                        <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>
                            Sinyal Kaynağı (mod_kaynak)<BilgiIkonu anahtar="sinyal_kaynagi" />
                        </div>
                        <input style={input} type="text"
                            value={ayarTaslak?.yom_mod_kaynak ?? ""}
                            onChange={e => setAyarTaslak(p => ({
                                ...p, yom_mod_kaynak: e.target.value }))} />
                    </div>
                </div>
                <div style={{ display: "flex", gap: 10, marginTop: 14,
                              alignItems: "center", flexWrap: "wrap" }}>
                    <button style={pill(ayarTaslak?.emir_tipi === "market")}
                            onClick={() => setAyarTaslak(p => ({ ...p, emir_tipi: "market" }))}>
                        Market Emir
                    </button>
                    <button style={pill(ayarTaslak?.emir_tipi === "limit")}
                            onClick={() => setAyarTaslak(p => ({ ...p, emir_tipi: "limit" }))}>
                        Limit Emir
                    </button>
                    <button style={pill(!!ayarTaslak?.sinyal_gecersiz_kapat)}
                            onClick={() => setAyarTaslak(p => ({
                                ...p, sinyal_gecersiz_kapat: !p.sinyal_gecersiz_kapat }))}>
                        Sinyal Geçersizse Kapat {ayarTaslak?.sinyal_gecersiz_kapat ? "✓" : ""}
                    </button>
                    <button style={pill(!!ayarTaslak?.pozisyon_buyuklugu_sinyalden)}
                            onClick={() => setAyarTaslak(p => ({
                                ...p, pozisyon_buyuklugu_sinyalden: !p.pozisyon_buyuklugu_sinyalden }))}>
                        Pozisyon Büyüklüğünü Sinyal Kaynağından Al {ayarTaslak?.pozisyon_buyuklugu_sinyalden ? "✓" : ""}
                    </button>
                    <div style={{ flex: 1 }} />
                    <button style={buton(C.accent, kaydediyor)} disabled={kaydediyor}
                            onClick={ayarKaydet}>
                        {kaydediyor ? "Kaydediliyor..." : "💾 Ayarları Kaydet"}
                    </button>
                </div>
            </div>

            {/* ── Metrikler ── */}
            <div style={kart}>
                <div style={kartBaslik}>📊 Performans Metrikleri</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: C.muted, margin: "0 0 8px" }}>
                    Kapanmış İşlemler
                </div>
                <div style={{ display: "grid",
                              gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
                              gap: 10 }}>
                    {[
                        ["İşlem", metrik?.toplam_islem, null],
                        ["Açık / Bekleyen", `${metrik?.acik ?? 0} / ${metrik?.bekleyen ?? 0}`, null],
                        ["Kazanma Oranı", metrik?.kazanma_orani !== null && metrik?.kazanma_orani !== undefined ? `%${num(metrik.kazanma_orani, 1)}` : "—", null],
                        ["Expectancy", metrik?.expectancy_pct !== null && metrik?.expectancy_pct !== undefined ? `%${num(metrik.expectancy_pct, 3)}` : "—", pnlRenk(metrik?.expectancy_pct), "expectancy"],
                        ["Ort. Kazanç", metrik?.ort_kazanc_pct !== null ? `%${num(metrik?.ort_kazanc_pct)}` : "—", C.yesil],
                        ["Ort. Kayıp", metrik?.ort_kayip_pct !== null ? `%${num(metrik?.ort_kayip_pct)}` : "—", C.kirmizi],
                        ["Profit Factor", num(metrik?.profit_factor), null, "profit_factor"],
                        ["Max Drawdown", metrik?.max_drawdown_pct !== null && metrik?.max_drawdown_pct !== undefined ? `%${num(metrik.max_drawdown_pct)}` : "—", C.kirmizi, "max_drawdown"],
                        ["Toplam PnL", num(metrik?.toplam_pnl), pnlRenk(metrik?.toplam_pnl)],
                        ["Bugün PnL", num(metrik?.bugun_pnl), pnlRenk(metrik?.bugun_pnl)],
                        ["Ort. MFE", metrik?.ort_mfe_pct !== null ? `%${num(metrik?.ort_mfe_pct)}` : "—", C.yesil, "ort_mfe"],
                        ["Ort. MAE", metrik?.ort_mae_pct !== null ? `%${num(metrik?.ort_mae_pct)}` : "—", C.kirmizi, "ort_mae"],
                    ].map(([l, v, renk, bilgi], i) => (
                        <div key={i} style={{ background: C.bg, borderRadius: 8,
                                              padding: "10px 12px",
                                              border: `1px solid ${C.border}` }}>
                            <div style={{ fontSize: 11, color: C.muted, display: "flex", alignItems: "center" }}>
                                {l}{bilgi ? <BilgiIkonu anahtar={bilgi} /> : null}
                            </div>
                            <div style={{ fontSize: 16, fontWeight: 700,
                                          color: renk || C.text, marginTop: 2 }}>
                                {v ?? "—"}
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ fontSize: 12, fontWeight: 700, color: C.muted, margin: "16px 0 8px" }}>
                    Açık Pozisyonlar (Gerçekleşmemiş)
                </div>
                <div style={{ display: "grid",
                              gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
                              gap: 10 }}>
                    {[
                        ["Açık Pozisyon", acikPoz.length, null],
                        ["Açık Maliyet", num(acikMaliyet), null],
                        ["Açık Güncel Değer", num(acikDeger), null],
                        ["Açık PnL", num(acikPnl), pnlRenk(acikPnl)],
                        ["Açık PnL %", acikPnlPct !== null ? `%${num(acikPnlPct)}` : "—", pnlRenk(acikPnlPct)],
                        ["Nakit (Sermaye)", num(ayar?.sermaye), null],
                        ["Toplam Varlık", num(toplamVarlik), null],
                    ].map(([l, v, renk], i) => (
                        <div key={`ap-${i}`} style={{ background: C.bg, borderRadius: 8,
                                              padding: "10px 12px",
                                              border: `1px solid ${C.border}` }}>
                            <div style={{ fontSize: 11, color: C.muted }}>{l}</div>
                            <div style={{ fontSize: 16, fontWeight: 700,
                                          color: renk || C.text, marginTop: 2 }}>
                                {v ?? "—"}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Açık pozisyonlar ── */}
            <div style={kart}>
                <div style={kartBaslik}>📂 Açık Pozisyonlar ({acikPoz.length})</div>
                {acikPoz.length === 0 ? (
                    <div style={{ fontSize: 13, color: C.muted }}>Açık pozisyon yok.</div>
                ) : (
                    <div style={{ overflowX: "auto", border: `1px solid ${C.border}`,
                                  borderRadius: 12 }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead><tr>
                                {["Sembol","Yön","Adet","Giriş","Maliyet","Anlık","Anlık Değer","PnL %",
                                  <>MFE %<BilgiIkonu anahtar="mfe_pct" /></>,
                                  <>MAE %<BilgiIkonu anahtar="mae_pct" /></>,
                                  "Stop","Hedef 1","Hedef 2","Sektör","Giriş Zamanı",""]
                                    .map((k, i) => <th key={i} style={th}>{k}</th>)}
                            </tr></thead>
                            <tbody>
                                {acikPoz.map(p => {
                                    const miktar = Number(p.miktar) || 0;
                                    const maliyet = Number(p.pozisyon_tutar) || 0;
                                    const anlikDeger = (p.anlik_fiyat !== null && p.anlik_fiyat !== undefined)
                                        ? Number(p.anlik_fiyat) * miktar : null;
                                    return (
                                    <tr key={p.id}>
                                        <td style={{ ...td, fontWeight: 700 }}>{p.sembol}</td>
                                        <td style={td}>{p.yon === "short" ? "📉 Short" : "📈 Long"}</td>
                                        <td style={td}>{num(miktar, 4)}</td>
                                        <td style={td}>{num(p.giris_fiyat, 4)}</td>
                                        <td style={td}>{num(maliyet)}</td>
                                        <td style={td}>{num(p.anlik_fiyat, 4)}</td>
                                        <td style={td}>{anlikDeger !== null ? num(anlikDeger) : "—"}</td>
                                        <td style={{ ...td, fontWeight: 700,
                                                     color: pnlRenk(p.anlik_pnl_pct) }}>
                                            {p.anlik_pnl_pct !== null && p.anlik_pnl_pct !== undefined
                                                ? `%${num(p.anlik_pnl_pct)}` : "—"}
                                        </td>
                                        <td style={{ ...td, color: C.yesil }}>%{num(p.mfe_pct)}</td>
                                        <td style={{ ...td, color: C.kirmizi }}>%{num(p.mae_pct)}</td>
                                        <td style={td}>{num(p.stop_loss, 4)}</td>
                                        <td style={td}>{num(p.hedef1, 4)}</td>
                                        <td style={td}>{num(p.hedef2, 4)}</td>
                                        <td style={td}>{p.sektor || "—"}</td>
                                        <td style={td}>{zamanFmt(p.giris_zaman)}</td>
                                        <td style={td}>
                                            <button style={buton(C.kirmizi)}
                                                    onClick={() => setKapatPopup(p)}>
                                                Kapat
                                            </button>
                                        </td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ── Kapanmış işlemler ── */}
            <div style={kart}>
                <div style={{ ...kartBaslik, justifyContent: "space-between" }}>
                    <span>📜 Kapanmış Paper İşlemler ({kapaliPoz.length})</span>
                    <button style={buton(C.border)} onClick={excelIndir}>⬇ Excel</button>
                </div>
                {kapaliPoz.length === 0 ? (
                    <div style={{ fontSize: 13, color: C.muted }}>Kapanmış işlem yok.</div>
                ) : (
                    <div style={{ overflowX: "auto", border: `1px solid ${C.border}`,
                                  borderRadius: 12, maxHeight: 420 }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead><tr>
                                {["Sembol","Giriş","Çıkış","Sebep","Maliyet","Değer","PnL","PnL %",
                                  <>MFE %<BilgiIkonu anahtar="mfe_pct" /></>,
                                  <>MAE %<BilgiIkonu anahtar="mae_pct" /></>,
                                  <>Slip %<BilgiIkonu anahtar="slip_pct" /></>,
                                  "Çıkış Zamanı"]
                                    .map((k, i) => <th key={i} style={th}>{k}</th>)}
                            </tr></thead>
                            <tbody>
                                {kapaliPoz.map(p => {
                                    const maliyet = Number(p.pozisyon_tutar) || 0;
                                    const deger = maliyet + (Number(p.pnl_tutar) || 0);
                                    return (
                                    <tr key={p.id}>
                                        <td style={{ ...td, fontWeight: 700 }}>{p.sembol}</td>
                                        <td style={td}>{num(p.giris_fiyat, 4)}</td>
                                        <td style={td}>{num(p.cikis_fiyat, 4)}</td>
                                        <td style={{ ...td, fontWeight: 600,
                                                     color: SEBEP_RENK[p.cikis_sebep] || C.muted }}>
                                            {p.cikis_sebep || "—"}
                                        </td>
                                        <td style={td}>{num(maliyet)}</td>
                                        <td style={td}>{num(deger)}</td>
                                        <td style={{ ...td, color: pnlRenk(p.pnl_tutar) }}>
                                            {num(p.pnl_tutar)}
                                        </td>
                                        <td style={{ ...td, fontWeight: 700,
                                                     color: pnlRenk(p.pnl_pct) }}>
                                            %{num(p.pnl_pct)}
                                        </td>
                                        <td style={{ ...td, color: C.yesil }}>%{num(p.mfe_pct)}</td>
                                        <td style={{ ...td, color: C.kirmizi }}>%{num(p.mae_pct)}</td>
                                        <td style={td}>%{num(p.slip_pct, 3)}</td>
                                        <td style={td}>{zamanFmt(p.cikis_zaman)}</td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ── Cron zinciri ── */}
            <div style={kart}>
                <div style={kartBaslik}>⛓️ Cron Zinciri — Son Çalışmalar<BilgiIkonu anahtar="cron_zinciri" /></div>
                {zincir.length === 0 ? (
                    <div style={{ fontSize: 13, color: C.muted }}>Henüz zincir kaydı yok.</div>
                ) : zincir.map(z => (
                    <div key={z.zincir_id}
                         style={{ display: "flex", gap: 8, alignItems: "center",
                                  flexWrap: "wrap", padding: "8px 0",
                                  borderBottom: `1px solid ${C.border}` }}>
                        <span style={{ fontSize: 11, color: C.muted, minWidth: 110 }}>
                            {zamanFmt(z.zaman)}
                        </span>
                        {z.adimlar.map(a => (
                            <span key={a.id} title={a.mesaj}
                                  style={{ fontSize: 11, fontWeight: 600,
                                           padding: "3px 10px", borderRadius: 99,
                                           border: `1px solid ${C.border}`,
                                           color: a.durum === "OK" ? C.yesil
                                                : a.durum === "UYARI" ? C.sari
                                                : a.durum === "ATLANDI" ? C.muted
                                                : C.kirmizi }}>
                                {a.adim}{a.para_birimi ? ` [${a.para_birimi}]` : ""}: {a.durum}
                            </span>
                        ))}
                    </div>
                ))}
            </div>

            {/* ── Bot döngü logu ── */}
            <div style={kart}>
                <div style={kartBaslik}>🧾 Bot Döngü Logu<BilgiIkonu anahtar="dongu_log" /></div>
                {donguLog.length === 0 ? (
                    <div style={{ fontSize: 13, color: C.muted }}>Henüz döngü kaydı yok.</div>
                ) : (
                    <div style={{ overflowX: "auto", border: `1px solid ${C.border}`,
                                  borderRadius: 12, maxHeight: 300 }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead><tr>
                                {["Zaman","İzin","İncelenen","Açılan","Kapanan","Atlanan","Mesaj"]
                                    .map((k, i) => <th key={i} style={th}>{k}</th>)}
                            </tr></thead>
                            <tbody>
                                {donguLog.map(l => (
                                    <tr key={l.id}>
                                        <td style={td}>{zamanFmt(l.zaman)}</td>
                                        <td style={{ ...td,
                                                     color: l.izin === true ? C.yesil
                                                          : l.izin === false ? C.kirmizi : C.muted }}>
                                            {l.izin === true ? "✓" : l.izin === false ? "✗" : "—"}
                                        </td>
                                        <td style={td}>{l.incelenen}</td>
                                        <td style={{ ...td, color: C.yesil }}>{l.acilan}</td>
                                        <td style={{ ...td, color: C.sari }}>{l.kapanan}</td>
                                        <td style={td}>{l.atlanan}</td>
                                        <td style={{ ...td, whiteSpace: "normal",
                                                     color: C.muted }}>{l.mesaj}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* ── Acil durdur popup ── */}
            {durdurPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
                              display: "flex", alignItems: "center",
                              justifyContent: "center", zIndex: 100 }}>
                    <div style={{ ...kart, width: 420, marginBottom: 0 }}>
                        <div style={kartBaslik}>🛑 Acil Durdurma</div>
                        <p style={{ fontSize: 13, color: C.muted, marginTop: 0 }}>
                            Kill-switch DURDURULDU'ya çekilir; bot yeni pozisyon açamaz.
                            Açık pozisyonlar otomatik kapanmaz — gerekirse tablodan
                            tek tek kapatabilirsiniz.
                        </p>
                        <input style={input} placeholder="Sebep (opsiyonel)"
                               value={durdurSebep}
                               onChange={e => setDurdurSebep(e.target.value)} />
                        <div style={{ display: "flex", gap: 8, marginTop: 14,
                                      justifyContent: "flex-end" }}>
                            <button style={buton(C.border)}
                                    onClick={() => setDurdurPopup(false)}>Vazgeç</button>
                            <button style={buton(C.kirmizi)} onClick={acilDurdur}>
                                🛑 Durdur
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Pozisyon kapat popup ── */}
            {kapatPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
                              display: "flex", alignItems: "center",
                              justifyContent: "center", zIndex: 100 }}>
                    <div style={{ ...kart, width: 400, marginBottom: 0 }}>
                        <div style={kartBaslik}>Pozisyonu Kapat</div>
                        <p style={{ fontSize: 13, color: C.muted, marginTop: 0 }}>
                            <b style={{ color: C.text }}>{kapatPopup.sembol}</b> ({kapatPopup.yon})
                            pozisyonu anlık fiyattan, slippage uygulanarak kapatılacak.
                        </p>
                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                            <button style={buton(C.border)}
                                    onClick={() => setKapatPopup(null)}>Vazgeç</button>
                            <button style={buton(C.kirmizi)} onClick={pozisyonKapat}>
                                Kapat (MANUEL)
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
}
